module.exports = __webpack_public_path__ + "img/비숍.0412699c.png";